import React from 'react';

const CustomPin = ({ pinColor, iconColor, iconPath }) => {
    return (
        <div className="relative w-16 h-16 flex items-center justify-center filter drop-shadow-lg hover:scale-110 transition-transform duration-300">
            {/* Pin Background */}
            <svg
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill={pinColor}
                className="absolute inset-0 w-full h-full"
            >
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
            </svg>

            {/* Icon Inside */}
            <div className="relative z-10 -mt-2 text-white" style={{ color: iconColor }}>
                {iconPath}
            </div>
        </div>
    );
};

export default CustomPin;
